import { Breadcrumb } from 'antd';
import { getUserType } from '../helpers/userDetails';
import MasterStaffHome from '../components/master-staff/MasterStaffHome';
import HomeComponent from '../components/home/HomeComponent';

const HomePage = () => {
  const userType = getUserType();
  const getComponent = () => {
    if (userType === 'MASTER_ADMIN' || userType === 'MASTER_NOC') {
      return <MasterStaffHome />;
    }
    // For ADMIN, MANAGER, SUPPORT
    return <HomeComponent />;
  };
  return <>{getComponent()}</>;
};
export default HomePage;
